import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { fetchAuthSession } from "aws-amplify/auth";

const proxyPrefix = process.env.REACT_APP_PROXY_PREFIX || '';
const baseApi = process.env.REACT_APP_API_BASE_URL || '';
const endPoint = 'v2/v2/sp';

const url = proxyPrefix + baseApi + endPoint

console.log('url', url)



//const url = process.env.REACT_APP_PROXY_PREFIX + 'https://devapi.revfer.com/v2/v2/sp'
console.log('url', url)

export const spApi = createApi({
  reducerPath: 'spApi',
  baseQuery: fetchBaseQuery({
    baseUrl: url,
    prepareHeaders: async (headers, { getState }) => {
        //const token = getState().auth.token
        //console.log('token', token)
        const session = await fetchAuthSession(); 
        const token = session.tokens.idToken.toString();
        console.log('my token in sp base api', token)
    
        // If we have a token set in state, let's assume that we should be passing it.
        if (token) {


          headers.set('Authorization', `${token}`)
          headers.set("Content-Type", "application/json")
        }
        //console.log('headers', headers)
    
        return headers
      },
  }),
  tagTypes: ['sp', 'spreviews', 'Spprofile', 'businessDetails', 'Subscription'],
  endpoints: () => ({}),
})
